import { useEffect } from 'react';

import tracker from 'utils/dio/navigation-tracker';

const PageViewTracker = () => {
  const { pathname, search, hash } = window.location;

  useEffect(() => {
    tracker.onPageView(pathname, search, hash);
  }, [pathname, search, hash]);
};

export default PageViewTracker;
